import { getEvents } from "@/common/service/eventsService";

export default {
  namespaced: true,

  // initial state
  state: {
    events: []
  },

  //mutations
  mutations: {
    setEvents(state, events) {
      state.events = events;
    }
  },

  //actions
  actions: {
    async loadEvents({ commit, dispatch }) {
      dispatch("error/setError", null, { root: true });
      try {
        const events = await getEvents();
        commit("setEvents", events);
      } catch (error) {
        dispatch("error/setError", error, { root: true });
      }
    }
  },

  //getters
  getters: {
    upcomingEvents: state => state.events.upcomingEvents,
    pastEvents: state => state.events.pastEvents
  }
};
